import {combineReducers} from 'redux'
import {IssueReducer} from './IssueReducer'
import {CustomFieldReducer} from './CustomFieldReducer'
import {AccountReducer} from './AccountReducer'
import {TemplateReducer} from './TemplateReducer'

const rootReducer = combineReducers({
  issues: IssueReducer,
  customFields: CustomFieldReducer,
  account: AccountReducer,
  templates: TemplateReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js